export const PLACEHOLDER_TEXT = "输入“/”命令或开始写作";
export const LIST_ITEM_PLACEHOLDER_TEXT = "条目";
export const PLACEHOLDER_COLOR_CLASS = "text-muted/50";
export const SELECTED_BLOCK_BACKGROND_COLOR = "bg-accent/20";
export const LEXICAL_NAMESPACE = "richtexteditor/v1";

/** 标题 1–6 级在菜单、工具条与空块 placeholder 中的统一文案（单一事实来源） */
export const HEADING_LEVEL_LABELS = [
  "一级标题",
  "二级标题",
  "三级标题",
  "四级标题",
  "五级标题",
  "六级标题",
] as const;

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

export function getHeadingLevelLabel(level: HeadingLevel): string {
  return HEADING_LEVEL_LABELS[level - 1];
}

/** Lexical HeadingNode tag，如 `h1`…`h6` */
export function getHeadingLabelFromTag(tag: string): string | null {
  const m = /^h([1-6])$/i.exec(tag.trim());
  if (!m) return null;
  const n = Number(m[1]);
  if (n < 1 || n > 6) return null;
  return getHeadingLevelLabel(n as HeadingLevel);
}
